module.exports = __webpack_public_path__ + "img/tab2.4a4e8e93.png";